/*
 *  (c) 2015 - 2023 ENISCO by FORCAM GmbH
 */

import React from 'react'
import {Button, ButtonGroup, Grid, Paper, Typography} from '@mui/material'
import {useError, useResolver, useUser} from '@enisco/mcc-react-lib'
import {useTheme} from '@mui/material/styles'

const UserInfoPage: React.FC = () => {
  const theme = useTheme()
  const [user] = useUser()
  const resolver = useResolver()
  const error = useError()

  const sendRequest = () => {
    resolver('mcc-portal-api', '/internal/get-config', {
      options: {
        cache: 'no-cache'
      }
    }).catch((err) => error(err, 'Request failed'))
  }

  return (
    <Paper sx={{height: '100vh', padding: 3}}>
      <Grid
        container
        sx={{
          gridGap: theme.spacing(1),
          display: 'grid',
          gridTemplateColumns: '200px auto'
        }}
      >
        <Grid item>
          <Typography variant='h6'>ID</Typography>
        </Grid>
        <Grid item>
          <Typography>{user?.uid}</Typography>
        </Grid>
        <Grid item>
          <Typography variant='h6'>Display name</Typography>
        </Grid>
        <Grid item>
          <Typography>{user?.userName}</Typography>
        </Grid>
        <Grid item>
          <Typography variant='h6'>E-Mail</Typography>
        </Grid>
        <Grid item>
          <Typography>{user?.email}</Typography>
        </Grid>
        <Grid item>
          <Typography variant='h6'> Permissions</Typography>
        </Grid>
        <Grid item>
          <Typography>{user?.permissions.join(', ')}</Typography>
        </Grid>
      </Grid>
      <ButtonGroup sx={{marginTop: 2}}>
        <Button variant='contained' onClick={sendRequest}>
          Request
        </Button>
      </ButtonGroup>
    </Paper>
  )
}

export default UserInfoPage
